module.exports = __webpack_public_path__ + "static/media/main_baemin_reset.0d972b27.mp4";